<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back">
        <mat-icon color="primary">arrow_back_ios</mat-icon>
    </button>
    <h3>{{ patient | patientHeading:'Prescription' }}</h3>
    <div>
        <button mat-icon-button [disabled]="!medicationAutocomplete?.isValid()" [matMenuTriggerFor]="emailMenu"
            [matTooltip]="'Send Prescription'">
            <mat-icon [color]="!medicationAutocomplete?.isValid() ? '' : 'primary'">send</mat-icon>
        </button>
        <mat-menu #emailMenu="matMenu" class="p-10 email-menu-panel">
            <div mat-menu-content (click)="$event.stopPropagation()">
                <mat-checkbox [(ngModel)]="includeSignatureOnEmail" class="checkbox" (click)="$event.stopPropagation()"
                    *ngIf="canSign">
                    Attach Signature
                </mat-checkbox>
                <app-recipient-search 
                    [patient]="patient"
                    [patientOnly]="true"
                    label="Quick Select Recipient"
                    placeholder="Search for recipient..."
                    (recipientSelected)="onRecipientSelected($event)">
                </app-recipient-search>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Email</mat-label>
                    <input matInput [(ngModel)]="email" type="email">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>CC Email</mat-label>
                    <input matInput [(ngModel)]="ccEmail" type="email">
                </mat-form-field>
                <button mat-raised-button (click)="emailPrescription()" color="primary" class="full-width">Email
                    Script</button>
            </div>
        </mat-menu>
        <button mat-icon-button [disabled]="!medicationAutocomplete?.isValid()" (click)="savePrescription()"
            matTooltip="Save Prescription">
            <mat-icon [color]="!medicationAutocomplete?.isValid() ? '' : 'primary'">save</mat-icon>
        </button>
    </div>
</mat-toolbar>

<div class="note-details-container">
    <!-- <form [formGroup]="form">
        <mat-card> -->
    <app-medication-autocomplete [patient]="patient" #medicationAutocomplete
        [initialData]="cloningMedication"></app-medication-autocomplete>
    <!-- </mat-card>
    </form> -->

    <div class="mobile-spacer"></div>
</div>